<app-page-meta pageTitle="finzy - Reports"></app-page-meta>
<section *ngIf="!showEmptyLrsPage" class="page-wrapper">
    <section class="header-wrapper-account">
        <article class="text-section-account">
            <h4 class="header-topic-account">
               finzyFLEX Account Statement
            </h4>
            <p class="header-detail-account">
                Here is the Statement of your finzyFLEX Account
            </p>
        </article>
        <article class="button-section-account">
            <button class="download-btn-account" (click)="accountStatementDownloadHandler()">Download</button>
        </article>
    </section>
    <section class="header-wrapper">
        <article class="text-section">
            <h4 class="header-topic">
                Investor Return Schedule
            </h4>
            <p class="header-detail">
                Here is the monthly summary of your finzyFLEX investments. For day wise details, you may download the Excel statement. 
            </p>
        </article>
        <article class="button-section">
            <button class="download-btn" (click)="openLrsReportDownloadPopup()">Download</button>
        </article>
    </section>
    <article class="artical-note">
        <span class="header-important">Important:</span>
        <span class="header-important-details">
        Numbers in IRS are displayed with two decimal places, however the
  calculations are happening at ten decimal places. This may lead to
  overstatement or understatement of displayed numbers on IRS. Please note,
  that the numbers on dashboard and in interest certificate are the actual
  numbers to be considered.
        </span>
    </article>
    <section class="filter-wrapper">
        <article class="filter-section">
            <div class="year-filter">
                <label class="year-txt" for="Year">Select Year</label>
                <div class="year-dropdown">
                    <mat-icon class="dropdown-icon">keyboard_arrow_down</mat-icon>
                    <mat-select class="year-select" [(ngModel)]="selectedYear" (ngModelChange)="filterByYear(selectedYear)" placeholder="Select Year">
                        <mat-option [value]="0">Select Year</mat-option>
                        <mat-option *ngFor="let year of yearList;" [value]="year">{{ year }}</mat-option>
                    </mat-select>
                </div>
            </div>
            <span class="or-text">or</span>
            <div class="date-filter">
                <label class="date-range-txt" for="date-range">Date Range</label>
                <div class="date-range">
                    <div class="from-date">
                        <mat-datepicker #fromDate startView="year" panelClass="lrs-month-picker" (monthSelected)="filterByMonthAndYear('startDate', $event, fromDate)"></mat-datepicker>
                        <div class="group-icon-input">
                            <img class="calender-icon" alt="calender-icon" src="../../../../../../assets/images/finzy-flex/calender_icon.svg" (click)="fromDate.open()" />
                            <input class="input-from-date" [placeholder]="fromDatePlaceHolder" matInput [matDatepicker]="fromDate" [(ngModel)]="selectedFromDate" readonly>
                        </div>
                    </div>
                    <span class="to-text">To</span>
                    <div class="from-date">
                        <mat-datepicker #toDate startView="year" panelClass="lrs-month-picker" (monthSelected)="filterByMonthAndYear('endDate', $event, toDate)"></mat-datepicker>
                        <div class="group-icon-input">
                            <img class="calender-icon" alt="calender-icon" src="../../../../../../assets/images/finzy-flex/calender_icon.svg" (click)="toDate.open()" />
                            <input class="input-from-date" [placeholder]="toDatePlaceholder" matInput [matDatepicker]="toDate" [(ngModel)]="selectedToDate" readonly>
                        </div>
                    </div>
                </div>
            </div>
        </article>
    </section>
    <section class="table-wrapper">
        <mat-spinner *ngIf="lrsReportList?.data.length < 1" class="spinner" [diameter]="100"></mat-spinner>
        <app-report-table
        [lrsReportList]="lrsReportList"></app-report-table>
        <span *ngIf="lrsReportList?.data.length <= 0" class="no-data-txt"> Data Not Found</span>
    </section>
    <section *ngIf="lrsReportList?.data.length > 0" class="pagination-wrapper">
        <div class="page-numbers">
            <mat-paginator
                paginator-style
                [length]="pageLength"
                [pageSize]="pageSize"
                [showTotalPages]="showTotalPages"
                [pageSizeOptions]="[10, 20, 50]"
            >
            </mat-paginator>
        </div>
    </section>
</section>
<section *ngIf="showEmptyLrsPage" class="empty-lrs-page">
    <app-empty-lrs></app-empty-lrs>
</section>
